/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalid_Date_FormatInputs */



/**
* | output |
* | --- |
* | "Invalid date format" |
*
* @param {Invalid_Date_FormatInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const invalid_date_format = /** @type {((inputs?: Invalid_Date_FormatInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalid_Date_FormatInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Invalid date format")
	return /** @type {LocalizedString} */ ("Format de date invalide")
});